// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__JiEcD","col":"styles_col__1fYX3"};